<template>
  <div class="container DCDetail">
    <el-tabs v-model="currentTab">
      <el-tab-pane :label="$t('DC.DCDetail')" name="1">
        <div class="searchBox_top">
          <el-button class="btn" size="mini" type="primary" v-if="isSave" @click="saveDetail" v-acl="DcSaveDCMasterData">{{$t('common.saveDraft')}}</el-button>
          <!--保存 MDM 状态为完成的时候 不显示保存-->
          <el-button class="btn" size="mini" type="primary" v-if="isSubmit" @click="submitDetail" v-acl="DcUpdateDCMasterData"> {{$t('common.submit')}}</el-button>
          <!--提交-->
          <el-button class="btn" size="mini" type="primary" @click="approval" v-if="isExamine" v-acl="SubmitCMasterDataDCMasterData">{{$t('supplierManage.audit')}}
          </el-button>
          <el-button class="btn" size="mini" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        </div>
        <div class="info_box_father">
          <div class="box">
            <div class="info_box_title">
              <p class="line"></p>
              <p class="info_title">Basic Information</p>
            </div>
            <el-form :model="DetailForm" ref="DetailForm" :rules="DetailRules" label-width="180px">
              <el-row>
                <el-col :span="8">
                  <!-- DCNumber字段由MDM进行编辑，供应商不可编辑。 -->
                  <!-- DC编码 -->
                  <el-form-item :label="$t('DC.DCNumber')" prop="supplierCode">
                    <el-input v-model.trim="DetailForm.supplierCode" maxlength="20" clearable :disabled="!(emplFlag=='MDM'&&(isExamine || isSubmit))" @blur="supplierCodeBlur($event)"></el-input>
                  </el-form-item>
                </el-col>
                <!-- 状态 -->
                <el-col :span="8">
                  <el-form-item :label="$t('common.status')" prop="status">
                    <ic-select table="TM_SUPPLIER" field="START_STATE" :disabled="!isSubmit || emplFlag=='SUP'" v-model="DetailForm.status"></ic-select>
                  </el-form-item>
                </el-col>
                <!-- 创建日期 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.createDate')" prop="createDate">
                    <el-date-picker v-model="DetailForm.createDate" type="date" value-format="yyyy-MM-dd" disabled :placeholder="$t('common.selDate')"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!-- DC名称 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.supplierName')" prop="supplierNameShort">
                    <el-input v-model="DetailForm.supplierNameShort" maxlength="33" clearable :disabled="!isSave && !isSubmit"></el-input>
                  </el-form-item>
                </el-col>
                <!-- DC简称 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.supplierNameShort')" prop="supplierName" :rules="emplFlag=='MDM' ? DetailRules.supplierName :[]">
                    <el-input v-model="DetailForm.supplierName" maxlength="33" clearable :disabled="!isSave && !isSubmit"></el-input>
                  </el-form-item>
                </el-col>
                <!-- DC类型 -->
                <!-- DC type由供应商、SS进行编辑 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.DCType')" prop="dctype">
                    <ic-select clearable table="TM_SUPPLIER" field="DC_TYPE" :disabled="!isSave && !isSubmit" v-model="DetailForm.dctype"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="国家" prop="country">
                    <el-select v-model="DetailForm.country" placeholder="请选择" @change="countryChange1" :disabled="!isSave && !isSubmit">
                      <el-option clearable v-for="item in countryList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="省份" prop="province">
                    <el-select v-model="DetailForm.province" placeholder="请选择" @change="provinceChange2" :disabled="!isSave && !isSubmit">
                      <el-option clearable v-for="item in provinceList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="市/县" prop="city">
                    <el-select v-model="DetailForm.city" placeholder="请选择" @change="cityChange2" :disabled="!isSave && !isSubmit">
                      <el-option clearable v-for="item in cityList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!-- 市/区 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.tmAreaId')" prop="tmAreaId">
                    <el-select v-model="DetailForm.tmAreaId" placeholder="请选择" @change="AreaChange" :disabled="!isSave && !isSubmit">
                      <el-option clearable v-for="item in AreaList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 详细地址 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.address')" prop="address">
                    <el-input v-model.trim="DetailForm.address" maxlength="33" clearable :disabled="!isSave && !isSubmit"></el-input>
                  </el-form-item>
                </el-col>
                <!-- 邮政编码 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.postCode')" prop="postCode">
                    <el-input v-model="DetailForm.postCode" clearable :disabled="!isSave && !isSubmit" maxLength='6' onkeyup="this.value=this.value.replace(/\D/g,'')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="联系人" prop="linkman">
                    <el-input v-model="DetailForm.linkman" clearable maxlength="20" :disabled="!isSave && !isSubmit"></el-input>
                  </el-form-item>
                </el-col>
                <!-- 手机号 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.telephoneNo')" prop="telephoneNo">
                    <el-input v-model="DetailForm.telephoneNo" clearable :disabled="!isSave && !isSubmit" maxlength="20"></el-input>
                  </el-form-item>
                </el-col>
                <!-- 邮箱 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.emailAddress')" prop="emailAddress">
                    <el-input v-model="DetailForm.emailAddress" maxlength="50" clearable :disabled="!isSave && !isSubmit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!-- 备注 -->
                <el-col :span="24">
                  <el-form-item :label="$t('common.remarks')" prop="description">
                    <el-input v-model="DetailForm.description" maxlength="33" clearable :disabled="!isSave && !isSubmit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="box" v-if="emplFlag != 'SUP'">
            <div class="info_box_title">
              <p class="line"></p>
              <p class="info_title">ADP</p>
            </div>
            <el-table :data="fpaLogisticRates" max-height="500" ref="fpaLogisticRates" border highlight-current-row style="margin-top: 10px ;" class="campaign_table PQCP">
              <el-table-column align="center" label="Transportation">
                <el-table-column align="center" prop="transportationRate" label="New Item Rate without VAT" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.transportationRate | fix(6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="transportationRateWithVat" label="New Item Rate with VAT" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.transportationRateWithVat | fix(6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="transportationVat" label="VAT Rate" show-overflow-tooltip min-width="100">
                  <template slot-scope="scope">
                    <span>{{scope.row.transportationVat | toPercent}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="transportationVatValue" label="New Item VAT Value" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.transportationVatValue | fix(6) }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column align="center" label="Warehouse">
                <el-table-column align="center" prop="warehouseRate" label="New Item Rate without VAT" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.warehouseRate | fix(6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="warehouseRateWithVat" label="New Item Rate with VAT" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.warehouseRateWithVat | fix(6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="warehouseVat" label="VAT Rate" show-overflow-tooltip min-width="100">
                  <template slot-scope="scope">
                    <span>{{scope.row.warehouseVat | toPercent}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="warehouseVatValue" label="New Item VAT Value" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.warehouseVatValue | fix(6) }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column align="center" prop="adpCost" label="Total ADP Cost(without VAT)" show-overflow-tooltip min-width="180">
                <template slot-scope="scope">
                  <span>{{scope.row.adpCost | fix(6) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="adpCostWithVat" label="Total ADP Cost(with VAT)" show-overflow-tooltip min-width="180">
                <template slot-scope="scope">
                  <span>{{scope.row.adpCostWithVat | fix(6) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="box" v-if="emplFlag != 'SUP'">
            <div class="info_box_title">
              <p class="line"></p>
              <p class="info_title">Planning Service</p>
            </div>
            <el-form ref="listForm" :model="listForm">
              <el-row>
                <el-col :span="9">
                  <el-form-item label="Agreed Price(price/case or tray in RMB with VAT)" prop="agreedPriceWithVat" label-width="290px">
                    <el-input v-model="listForm.agreedPriceWithVat" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="per" prop="agreedPriceWithVatUnit" label-width="60px">
                    <el-input v-model="listForm.agreedPriceWithVatUnit" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="Agreed Price(price/case or tray in RMB without VAT)" prop="agreedPrice" label-width="300px">
                    <el-input disabled v-model="listForm.agreedPrice" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="per" prop="agreedPriceUnit" label-width="60px">
                    <el-input v-model="listForm.agreedPriceUnit" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="VAT Rate" prop="settleVat" label-width="290px">
                    <el-input v-model="listForm.settleVat" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Settle" prop="settleDcName" label-width="300px">
                    <el-input v-model="listForm.settleDcName" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="2">
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime') ">
            <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName') "></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation') "></el-table-column>
          <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.opinion') "></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :title="$t('supplierManage.approvalWindow')" :visible.sync="approvalVisible" width="400px">
      <el-form :model="approvaForm" ref="approvaForm" :rules="approvaRules" inline label-width="90px">
        <el-form-item :label="$t('storeFeedback.auditor')" prop="auditor">
          <el-input v-model="approvaForm.auditor" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.approvalTime') " prop="approvalTime">
          <el-input v-model="approvaForm.approvalTime" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.approvalResults') " prop="auditStatus">
          <el-radio-group v-model="approvaForm.auditStatus">
            <el-radio label="approve">{{$t('common.pass')}}</el-radio>
            <el-radio label="reject">{{$t('common.noPass')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('common.approvalRemarks') " prop="remarks" :rules="approvaForm.auditStatus == 'reject' ? approvaForm.remarks :[]">
          <el-input v-model="approvaForm.remarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="300" style="width:200px"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approvalVisible = false" type="primary">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="approvalConfirm()">{{$t('common.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import supplierApi from "@/api/supplier/supplier";
import DCApi from "@/api/DC/DC";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";

export default {
  components: { IcSelect },
  data() {
    let validaPostCode = (rule, value, callback) => {
      let that = this;
      if (!value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else if (value.length < 6) {
        callback(new Error('长度不符合要求'));
      } else {
        callback();
      }
    };
    return {
      isSave: true,
      isSubmit: true,
      isExamine: false,
      tempAddress: '',
      currentTab: '1',
      id: '',      
      countryList: [],
      provinceList: [],
      cityList: [],
      AreaList: [],
      auditLog: [],//审批日志
      approvaForm: {
        auditor: localStorage.getItem("ms_username"),
        approvalTime: this.$options.filters["dateFormatFilter"](new Date()),
        auditStatus: 'approve',
        remarks: '',
        tmSupplierId: null,
      },
      approvaRules: {
        auditStatus: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        remarks: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
      },
      approvalVisible: false,
      DetailForm: {
        dctype: '',
        supplierName: '',
        emailAddress: '',
        country: '',
        province: '',
        city: '',
        tmAreaId: '',
        telephoneNo: '',
        address: '',
        postCode: '',
        futureEffectiveDate: '',
        status: 1,
        linkman: '',
        createDate: this.$options.filters["dateFormatFilter"](new Date()),
      },
      countryName: '',
      provinceName: '',
      cityName: '',
      areaName: '',
      DetailRules: {
        supplierNameShort: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        dctype: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        supplierName: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        country: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ['change', 'blur'] }
        ],
        province: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ['change', 'blur'] }
        ],
        city: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ['change', 'blur'] }
        ],
        tmAreaId: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ['change', 'blur'] }
        ],
        telephoneNo: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        address: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        postCode: [
          { required: true, validator: validaPostCode, trigger: "blur" }
        ],
      },
      auditStatus: '',
      emplFlag: '',
      emplFlag2: '',
      SSlogistic: false,
      fpaLogisticRates: [],
      listForm: {
        agreedPrice: "",
        agreedPriceUnit: "",
        agreedPriceWithVat: "",
        agreedPriceWithVatUnit: "",
        settleDcName: "",
        settleVat: "",
        settleVatValue: "",
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id)
      this.id = this.$route.query.id
    }
    this.getArea()
    //用户所属系统(SUP供应商)
    const emplFlag = localStorage.getItem("ms_emplFlag");
    console.log(emplFlag)
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
    } else {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {
          this.emplFlag = 'MDM';
        }
        if (permission[i] == 'dc_ss_business_audit') {
          this.emplFlag2 = 'SS';
        }
      }
    }
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SS Category leader logistic') {
        this.SSlogistic = true;
      }
    }

  },
  methods: {
    getDetail(id) {
      let that = this
      DCApi.getDetail(id).then(res => {
        if (res.resultData[0].country) {
          that.countryChange(res.resultData[0].country)
          that.provinceChange(res.resultData[0].province)
          that.cityChange(res.resultData[0].city)
        }
        Promise.all([that.countryChange(), that.provinceChange(), that.cityChange()]).then(() => {
          if (res.resultData[0].country) {
            that.DetailForm.country = parseInt(res.resultData[0].country)
            that.DetailForm.province = parseInt(res.resultData[0].province)
            that.DetailForm.city = parseInt(res.resultData[0].city)
            that.DetailForm.tmAreaId = res.resultData[0].tmAreaId
          }
        })
        this.DetailForm = res.resultData[0]
        let dcRateInfo = res.resultData[1]?res.resultData[1]:{};
        this.fpaLogisticRates = res.resultData[1]?[res.resultData[1]]:[]
        this.listForm.agreedPriceWithVat = dcRateInfo.agreedPriceWithVat ? dcRateInfo.agreedPriceWithVat.toFixed(6) : ''
        this.listForm.agreedPriceWithVatUnit = dcRateInfo.agreedPriceWithVatUnit
        this.listForm.agreedPrice = dcRateInfo.agreedPrice ? dcRateInfo.agreedPrice.toFixed(6) : ""
        this.listForm.agreedPriceUnit = dcRateInfo.agreedPriceUnit
        this.listForm.settleVat = dcRateInfo.settleVat ? (dcRateInfo.settleVat * 100) + '%' : dcRateInfo.settleVat == 0 ? 0 : ''
        this.listForm.settleVatValue = dcRateInfo.settleVatValue
        this.listForm.settleDcName = dcRateInfo.settleDcName
        if (this.DetailForm.adpwotax) {
          this.DetailForm.adpwotax = Number(this.DetailForm.adpwotax).toFixed(6);
        }
        if (this.DetailForm.adp) {
          this.DetailForm.adp = Number(this.DetailForm.adp).toFixed(6);
        }
        if (this.DetailForm.futureADPwotax) {
          this.DetailForm.futureADPwotax = Number(this.DetailForm.futureADPwotax).toFixed(6);
        }
        // if(this.emplFlag2 == 'SS' && res.resultData[0].isExamine){
        //     this.isSave = true
        // }
        this.auditStatus = res.resultData[0].auditStatus//1 Draft 创建 2 ongoing 进行中 3 submit 待MDM审批 4 approve 完成 5 reject 审批退回
        this.isSubmit = res.resultData[0].isSubmit
        that.isSave = res.resultData[0].isSave
        that.auditLog = res.resultData[0].workFlowLogList
        this.$nextTick(() => {
          this.isExamine = res.resultData[0].isExamine
        });
      });
    },
    saveDetail() {
      let that = this;
      //supplierNameShort 必填
      let validFlag = false;
      this.$refs.DetailForm.validateField("supplierNameShort", errMsg => {
        if (!errMsg) {
          validFlag = true;
        }
      });
      if (!validFlag) {
        return;
      }
      if (that.DetailForm.adpwotax) {
        that.DetailForm.adpwotax = Number(that.DetailForm.adpwotax).toFixed(6);
      }
      if (that.DetailForm.adp) {
        that.DetailForm.adp = Number(that.DetailForm.adp).toFixed(6);
      }
      if (that.DetailForm.futureADPwotax) {
        that.DetailForm.futureADPwotax = Number(that.DetailForm.futureADPwotax).toFixed(6);
      }
      let data = that.DetailForm
      // if(!that.id){
      //   const emplFlag = localStorage.getItem("ms_emplFlag");
      //     //供应商用户
      //     if (emplFlag === 'SUP') {
      //         data.auditStatus = 'Draft'
      //     }else{
      //         data.auditStatus = 'ongoing'
      //     }
      // }
      console.log(data)
      DCApi.save(data).then(res => {
        if (res.code == 200) {
          this.id = res.data
          that.$message({
            message: this.$t("common.saveSuccess"),
            type: "success"
          });
          that.getDetail(res.data)
          that.$router.replace({
            path: `/DCDetail`,
            query: {
              id: res.data,
              timestamp: new Date().getTime()
            }
          })
        }
        if (res.code == '非200') {
          that.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    submitDetail() {
      let that = this;
      // if (this.DetailForm.futureEffectiveDate) {
      //     //考虑到ie，需要做时间转换
      //     let strtime = this.DetailForm.futureEffectiveDate.replace("/-/g", "/");
      //     let date1 = new Date(strtime);
      //     let date2 = new Date();
      //     if (date1 < date2) {
      //         that.$message({
      //             message: "未来有效时间必须大于当前时间",
      //             type: "warning"
      //         });
      //         return
      //     }
      // }
      this.$refs.DetailForm.validate(valid => {
        if (valid) {
          if (that.DetailForm.adpwotax) {
            that.DetailForm.adpwotax = Number(that.DetailForm.adpwotax).toFixed(6);
          }
          if (that.DetailForm.adp) {
            that.DetailForm.adp = Number(that.DetailForm.adp).toFixed(6);
          }
          if (that.DetailForm.futureADPwotax) {
            that.DetailForm.futureADPwotax = Number(that.DetailForm.futureADPwotax).toFixed(6);
          }
          let data = that.DetailForm
          const emplFlag = localStorage.getItem("ms_emplFlag");
          //供应商用户
          if (emplFlag === 'SUP') {
            data.auditStatus = 'Draft'
          } else {
            data.auditStatus = 'ongoing'
          }
          console.log(data)
          DCApi.submit(data).then(res => {
            if (res.code == '200') {
              that.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
              that.historyBack();
            }
            if (res.code == '非200') {
              that.$message({
                message: res.msg,
                type: "warning"
              });
            }
          });
        } else {
          Message({ message: this.$t("visitPlan.noEmpty"), type: "error" });
          return false;
        }
      });
    },
    //审批
    approval() {
      this.approvalVisible = true
    },
    //审批
    approvalConfirm() {
      let that = this;
      this.$refs.approvaForm.validate(valid => {
        if (valid) {
          //先判断是不是审批通过 并且是MDM DCNumber如果为空
          if (that.approvaForm.auditStatus == 'approve' && that.emplFlag == "MDM" && commonFun.isEmpty(that.DetailForm.supplierCode)) {
            Message({ message: 'DC Number必填', type: "error" });
            return false
          }
          if (that.approvaForm.auditStatus == 'approve' && commonFun.isEmpty(that.DetailForm.supplierName)) {
            Message({ message: 'DC简称必填', type: "error" });
            return false
          }
          let data = {}
          if (that.approvaForm.auditStatus == 'approve' && that.emplFlag == "MDM") {//通过
            data.supplierCode = that.DetailForm.supplierCode
          }
          if (that.SSlogistic || that.emplFlag == "MDM") {//如果是SS 或者MDM
            that.$refs.DetailForm.validate(valid => {
              if (valid) {
                data.dctype = that.DetailForm.dctype
                data.supplierName = that.DetailForm.supplierName
                data.emailAddress = that.DetailForm.emailAddress
                data.country = that.DetailForm.country
                data.province = that.DetailForm.province
                data.city = that.DetailForm.city
                data.tmAreaId = that.DetailForm.tmAreaId
                data.status = that.DetailForm.status
                data.telephoneNo = that.DetailForm.telephoneNo
                data.postCode = that.DetailForm.postCode
                data.address = that.DetailForm.address
                data.description = that.DetailForm.description
                var status = 'submit';
                if (this.approvaForm.auditStatus === 'reject') {//拒绝
                  status = 'reject'
                }
                if (that.emplFlag == "MDM") {
                  that.approvaForm.auditStatus = 'ongoing'
                }
                if (that.emplFlag2 == "SS") {
                  that.approvaForm.auditStatus = ''
                }
                data.tmSupplierId = that.id,
                  data.status = status,
                  data.remarks = that.approvaForm.remarks,
                  data.auditStatus = that.approvaForm.auditStatus
                console.log(data)
                // Message({message: this.$t('common.operateSuccess'), type: "success"});
                DCApi.approval(data).then(res => {
                  if (res.code === '200') {
                    Message({ message: this.$t('common.operateSuccess'), type: "success" });
                    that.historyBack();
                  } else {
                    Message({ message: res.msg, type: "error" });
                    that.approvaForm.auditStatus = 'approve'
                    this.approvalVisible = false
                  }
                });
              } else {
                that.approvalVisible = false
                Message({ message: this.$t("visitPlan.noEmpty"), type: "error" });
                return false;
              }
            });
          } else {
            var status = 'submit';
            if (this.approvaForm.auditStatus === 'reject') {//拒绝
              status = 'reject'
            }
            if (that.emplFlag == "MDM") {
              that.approvaForm.auditStatus = 'ongoing'
            }
            if (that.emplFlag2 == "SS") {
              that.approvaForm.auditStatus = ''
            }
            data.tmSupplierId = that.id,
              data.status = status,
              data.remarks = that.approvaForm.remarks,
              data.auditStatus = that.approvaForm.auditStatus
            DCApi.approval(data).then(res => {
              if (res.code === '200') {
                Message({ message: this.$t('common.operateSuccess'), type: "success" });
                that.historyBack();
              } else {
                Message({ message: res.msg, type: "error" });
                that.approvaForm.auditStatus = 'approve'
                this.approvalVisible = false
              }
            });
          }


        } else {
          return false;
        }
      });
      this.approvalVisible = true
    },
    //获取国家
    getArea() {
      let that = this
      let data = {
        areaLevel: '0',
      }
      supplierApi.getArea(data).then(res => {
        this.countryList = res.data
      });
    },
    countryChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        that.DetailForm.province = ''
        that.DetailForm.city = ''
        that.DetailForm.tmAreaId = ''
        let data = {
          areaLevel: '1',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          that.provinceList = res.data
          resolve()
        });
      })
    },
    provinceChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        that.DetailForm.city = ''
        that.DetailForm.tmAreaId = ''
        let data = {
          areaLevel: '2',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.cityList = res.data
          resolve()
        });
      })

    },
    supplierCodeBlur(val) {
      let that = this
      if (event.target.value) {
        DCApi.getDCMumber(event.target.value).then(res => {
          console.log(res)
          if (res.resultData.length != 0) {
            if (res.resultData[0].tmSupplierId != that.id) {
              Message({ message: this.$t('DC.DcnumberExists'), type: "error" });
            }
          }

        });
      }

    },
    //城市选择之后 获取区域
    cityChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        that.DetailForm.tmAreaId = ''
        let data = {
          areaLevel: '3',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.AreaList = res.data
          resolve()
        });
      })

    },
    //国家选择之后 获取省份
    countryChange1(val) {
      let that = this
      let selectedWorkName = {};
      selectedWorkName = this.countryList.find((item) => {
        return item.tmAreaId === val;
        //筛选出匹配数据，是对应数据的整个对象
      });
      that.countryName = selectedWorkName.name
      that.DetailForm.province = ''
      that.DetailForm.city = ''
      that.DetailForm.tmAreaId = ''
      that.DetailForm.locationReference = ''
      this.DetailForm.locationReferenceRegionAdd = ''
      let data = {
        areaLevel: '1',
        parentId: val
      }
      supplierApi.getArea(data).then(res => {
        that.provinceList = res.data
      });
    },
    //省份选择之后 获取市
    provinceChange2(val) {
      let that = this
      let selectedWorkName = {};
      selectedWorkName = this.provinceList.find((item) => {
        return item.tmAreaId === val;
        //筛选出匹配数据，是对应数据的整个对象
      });
      that.provinceName = selectedWorkName.name
      that.DetailForm.city = ''
      that.DetailForm.tmAreaId = ''
      that.DetailForm.locationReference = ''
      that.DetailForm.locationReferenceRegionAdd = ''
      let data = {
        areaLevel: '2',
        parentId: val
      }
      supplierApi.getArea(data).then(res => {
        this.cityList = res.data
      });
    },
    //城市选择之后 获取区域
    cityChange2(val) {
      let that = this
      let selectedWorkName = {};
      selectedWorkName = this.cityList.find((item) => {
        return item.tmAreaId === val;
        //筛选出匹配数据，是对应数据的整个对象
      });
      that.cityName = selectedWorkName.name
      that.DetailForm.tmAreaId = ''
      that.DetailForm.locationReference = ''
      that.DetailForm.locationReferenceRegionAdd = ''
      let data = {
        areaLevel: '3',
        parentId: val
      }
      supplierApi.getArea(data).then(res => {
        this.AreaList = res.data
      });
    },
    //国家省市区全部选完
    AreaChange(val) {
      let that = this
      let selectedWorkName = {};
      selectedWorkName = this.AreaList.find((item) => {
        return item.tmAreaId === val;
        //筛选出匹配数据，是对应数据的整个对象
      });
      that.areaName = selectedWorkName.name
      this.DetailForm.locationReference = val
      this.DetailForm.locationReferenceRegionAdd = this.countryName + this.provinceName + this.cityName + this.areaName
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = 4484;
      attachment.tsReckindId = 'QUOTATION_APPLY';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.ttQuotationApplyId;
        attachment.tsReckindId = 'QUOTATION_APPLY';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => {
      })
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    blurInput(e, prop) {
      this.DetailForm.prop = e.target.value
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    toFixedValue: function (value) {
      if (value) {
        value = Number(value).toFixed(6)
      }
    },
    oninput(num) {
      var str = num
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      var lenLast = str.substr(str.length - 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1)
      }
      //第一位不能是.
      if (len1 == ".") {
        str = ""
      }
      //最后一位不能是.
      if (str.length == 8 && lenLast == ".") {
        str = ""
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1)
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
        }
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
      str = (str.match(/^\d*(\.?\d{0,6})/g)[0]) || null
      // 小数点后只能输两位
      return str
    }
  }

}
</script>
<style lang="scss" scoped>
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
}
.info_title {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
  float: left;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
  float: left;
}

.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}

.noLeft {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-card {
  // .el-select{
  //     width:20%;
  // }
  // .el-date-editor{
  //     width: 20%;
  // }
  // .el-input{
  //     width: 20%;
  // }
}
</style>
<style lang="scss">
.noLeft {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.noLeft2 {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.flexBox {
  .el-row {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .el-radio__label {
      width: 100px;
      display: inline-block;
    }
  }
}
.DCDetail
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: "";
}
.info_box_father {
  width: calc(100% - 16px);
  padding: 0 8px;
}
.box {
  // width: 100%;
  // height: auto;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
  margin-bottom: 15px;
  border-radius: 8px;
  padding: 0 8px;
}
</style>
